<div class="cald_dialog">
  <div class="cald_header">
    <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="cancel()">&#xe03e;</button>
    <h2>{{data.title | translate }}</h2>
  </div>
  <div class="cald_content" [ngClass]="data.modalBodyClass">
    <div class="cpq-scroll">
      <div class="cpq-dialog-content-scroll">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <div class="data-content">{{data.content | translate}}</div>
              @if (data.additionalContent) {
                <div class="cald_content cald_additional_content">{{data.additionalContent}}</div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="form-inline cald_dialog_buttonbar">
    <button class="btn btn-primary fiori3-btn-primary" (click)="confirm()">{{data.yesMsg | translate}}</button>
    <button class="btn btn-tertiary fiori3-btn-tertiary" (click)='cancel()'>{{'Msg.Cancel' | translate}}</button>
  </div>
</div>